import {PipeTransform, Pipe} from '@angular/core';
import {Json} from '../facade/lang';
export class JsonPipe implements PipeTransform {
  transform(value: any): string { return Json.stringify(value); }
static decorators: DecoratorInvocation[] = [
{ type: Pipe, args: [{name: 'json', pure: false}, ] },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
